import { t } from 'i18next';
import { INVALID_DATE } from './fullDateFormatter';
import moment from 'moment';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from '../../../i18n';

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const buildCustomDate = (date: Date): string => {
  if (date.toString() === INVALID_DATE) {
    throw new Error(INVALID_DATE);
  }
  const language = i18n.use(LanguageDetector).language;
  var noSufix = ['es', 'pt'];
  if (!noSufix.some((el) => language.includes(el))) {
    return `${moment(date).format('Do')} ${t(MONTH_NAMES[date.getMonth()])}`;
  }

  return `${date.getDate()} ${t(MONTH_NAMES[date.getMonth()])}`;
};
